import React from 'react';
import { UIMomentContextProps } from './UIMomentContext';



export const MomentVideo: React.FC<UIMomentContextProps> = (props) => {
  const {
    moment,
  } = props;
  
  return (
    <>
      momentVideo
    </>
  );
};